import React from 'react';
import {Col, Row} from 'reactstrap';

const PopupHeadlineComponent = (props) => {
 return (
     <Row>
        <Col>
            <span className="bold d-block popup-component-headline" dangerouslySetInnerHTML={{ __html: props.title }} />
        </Col>
     </Row>
 )
}

export default PopupHeadlineComponent;